module.exports = __webpack_public_path__ + "pdf-pie.722d0bdd1bb831883c30.png";


//////////////////
// WEBPACK FOOTER
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/assets/img/pdf/pdf-pie.png
// module id = ../../../../../src/assets/img/pdf/pdf-pie.png
// module chunks = main